/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Continue_ListeningInputs */

const en_dashboard_continue_listening = /** @type {(inputs: Dashboard_Continue_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue listening`)
};

const es_dashboard_continue_listening = /** @type {(inputs: Dashboard_Continue_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar escuchando`)
};

/**
* | output |
* | --- |
* | "Continue listening" |
*
* @param {Dashboard_Continue_ListeningInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dashboard_continue_listening = /** @type {((inputs?: Dashboard_Continue_ListeningInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Continue_ListeningInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dashboard_continue_listening(inputs)
	return en_dashboard_continue_listening(inputs)
});